import * as z from 'zod';

export const tcTemplateQueryLinkerSchema = z.object({
  id: z.number(),
  name: z.string(),
});

export type TcTemplateQueryLinkerSchema = z.infer<typeof tcTemplateQueryLinkerSchema>;
